export const stringTruncate = (str: string, maxLength: number) => {
  const length = str.length;

  if (length > maxLength) {
    return str.substring(0, maxLength) + '...';
  }
  return str;
};
